import React, { useState } from "react";
// import "./LineRange.css"; // You can adjust the CSS file as needed

function App() {
  const initialPercentage = 20; // Set your desired initial percentage here, or null if none
  const [percentage, setPercentage] = useState(initialPercentage);

  const handleClick = () => {
    // Handle click to update the state (percentage)
    const newPercentage = initialPercentage === null ? 20 : null;
    setPercentage(newPercentage);
  };

  const handleMouseMove = (e) => {
    // Handle hover to change the color without updating the state (percentage)
    if (percentage !== null) {
      const newPercentage = Math.min(
        Math.floor((e.nativeEvent.offsetX / e.target.clientWidth) * 5) * 20 +
          20,
        100
      );
      setPercentage(newPercentage);
    }
  };

  const outerDivStyle = {
    background: "gray",
    borderRadius: "8px",
    width: "200px", // Set your desired width
    height: "16px", // Set your desired height
    position: "relative",
    overflow: "hidden",
  };

  const innerDivStyle = {
    width: `${percentage || 0}%`,
    height: "100%",
    background: "#00ff00", // Set your desired fill color
    transition: "width 0.3s",
    position: "absolute",
    left: "0",
    top: "0",
    borderRadius: `${percentage === 100 ? "8px" : "0 8px 8px 0"}`,
  };

  return (
    <div
      className="color-fill-div"
      onMouseMove={handleMouseMove}
      onClick={handleClick}
      style={outerDivStyle}
    >
      <div style={innerDivStyle}></div>
      {percentage}%
    </div>
  );
}

export default App;
